// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__n7ygh","showOnDesktop":"Navbar_showOnDesktop__6I48G","socials":"Navbar_socials__3Oghl","showOnMobile":"Navbar_showOnMobile__WK7TP"};